import type { LandingGender } from "@client/app/Info/Landing/LandingAvatar/types";

export const SECTION_IDS = {
	about: "about",
	rooms: "rooms",
	cities: "cities",
	customization: "customization",
	top: "top",
} as const;

export const NAV_ITEMS = [
	{ id: SECTION_IDS.about, label: "nav.about" },
	{ id: SECTION_IDS.rooms, label: "nav.rooms" },
	{ id: SECTION_IDS.cities, label: "nav.customization" },
	{ id: SECTION_IDS.top, label: "nav.top" },
] as const;

export const TELEGRAM_URL = "https://t.me/capitalisto_io";
export const TELEGRAM_CHAT_URL = "https://t.me/capitalisto_io_chat";
export const CONTACT_EMAIL = "capitalisto@capitalisto.io";
export const INSTAGRAM_URL = "";
export const DISCORD_URL = "";

export const CONTAINER_CLASS =
	"relative mx-auto w-full max-w-[1748px] px-4 md:px-8 xl:px-[88px]";

export const MEDIA_MD = "(min-width: 48rem)";
export const MEDIA_LG = "(min-width: 64rem)";

export const SECTION_SCROLL_MARGIN = "scroll-mt-24 lg:scroll-mt-32";

export const SAMPLE_NAMES: Record<LandingGender, readonly string[]> = {
	female: [
		"general:olena",
		"general:maria",
		"general:anastasia",
		"general:sofia",
		"general:daryna",
		"general:kateryna",
		"general:oksana",
		"general:yulia",
		"general:viktoriia",
		"general:iryna",
		"general:natalia",
		"general:svitlana",
	],
	male: [
		"general:andrii",
		"general:oleksandr",
		"general:bohdan",
		"general:taras",
		"general:maksym",
		"general:nazar",
		"general:dmytro",
		"general:ivan",
		"general:artem",
		"general:mykhailo",
		"general:roman",
		"general:serhii",
	],
};

export const SAMPLE_AVATAR_POOL = 24;
